import React, { Component } from 'react'
import { GetFiliaisDetails, GetLogProcessosDetails } from '../../services';
import swal from 'sweetalert';
import PropTypes from 'prop-types';

import axios from 'axios';

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CFormLabel,
  CFormSelect,
  CButton,
} from '@coreui/react'

import AutoSelect from '../../common/autoselect';

const Arrays = (data, fieldName, fieldValue) => {
  let arrayItem = [];
  if (data && Array.isArray(data)) {
    data.forEach((item) => {
      arrayItem.push({ label: item[fieldName], value: item[fieldValue] });
    });
  }
  return arrayItem;
};

export default class List extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    state: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.CallLog = this.CallLog.bind(this);
    this.CallLogSaida = this.CallLogSaida.bind(this);
    this.CallLogEntradaOT = this.CallLogEntradaOT.bind(this);
    this.CallPedidos = this.CallPedidos.bind(this);
    this.goToOmieTabelaPrecos = this.goToOmieTabelaPrecos.bind(this);
    this.goToOmieTabelaPrecosExec = this.goToOmieTabelaPrecosExec.bind(this);

    this.state = {
      getList: [],
      isLoaded: false,
      id_filial: 0,
      operadora: '',
      nome: '',
      id_filials: 0,
      operadorasa: '',
      nomes: '',
      id_filial2: 0,
      operadora2: '',
      nome2: '',
      id_filial_omie: 0,
      nome_filial_omie: '',
    }
  }

  async componentDidMount() {
    this.getFiliais();
  }

  handleSelectChange = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected.value,
      },
      id_filial: selected.value,
      nome: selected.label,
      changed: true,
    });
  };

  handleSelectChanges = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected.value,
      },
      id_filials: selected.value,
      nomes: selected.label,
      changed: true,
    });
  };

  handleSelectChange2 = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected.value,
      },
      id_filial2: selected.value,
      nome2: selected.label,
      changed: true,
    });
  };

  handleSelectOmieTabelaPreco = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected.value,
      },
      id_filial_omie: selected.value,
      nome_filial_omie: selected.label,
      changed: true,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  async getFiliais() {
    this.setState({ isLoaded: true })
    let list = await GetFiliaisDetails.FilialList();
    if (list) {
      this.setState({ getList: list.data })
    }
    this.setState({ isLoaded: false })
  }

  CallLog() {
    this.props.history.push({ pathname: `/admin/ctrl/list/` })
  }

  CallLogEntradaOT() {
    this.props.history.push({ pathname: `/admin/ctrlEntrada_OT/list/` })
  }

  CallLogSaida() {
    this.props.history.push({ pathname: `/admin/ctrlSaida/list/` })
  }

  CallPedidos() {
    this.props.history.push({ pathname: `/admin/pedidos/list/` })
  }

  async CallApiSaida(id_log) {
    const { id_filials, operadorasa } = this.state;
    //const res = await axios.get('http://localhost:9004/pedidos1', {
    const res = await axios.get('https://integradorbaoba.masterdaweb.net/api/nf_saida/getNFESaida', {
      params: { cd_estabelecimento: id_filials, operadora: operadorasa, id_log: id_log },
    });
    return res.data
  }


EnviaSaida = async (event) => {
    event.preventDefault();
    const { id_filials, operadorasa, nomes } = this.state;


    if (!id_filials && id_filials != 0) {
      swal("Aviso!", 'Por favor, escolha uma filial!', "warning");
      return;
    }

    if (!operadorasa.trim()) {
      swal("Aviso!", 'Por favor, escolha uma operadora!', "warning");
      return;
    }

    swal({
      title: "Deseja enviar NF de saída para  " + nomes + " ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (success) => {
        if (success) {
          //await this.CallApi();
          let { id_filials, operadorasa } = this.state;
          let data = { nome: 'Saída NFs', mensagem: 'Iniciada', status: "Iniciada", cd_estabelecimento: id_filials, operadora: operadorasa }
          // make API call
          let log = await GetLogProcessosDetails.AddLogProcessos(data);
          console.log(log.data.id)
          this.CallApiSaida(log.data.id)
          this.props.history.push({
            pathname: '/admin/entrada/list/',
            state: {
              id_filial: id_filials,
              nome_filial: nomes,
              operadora: operadorasa,
              processo: 'Saída NFs'
            }
          });
        }
      });
  }


  goToOmieTabelaPrecos() {
    const { id_filial_omie, nome_filial_omie } = this.state;

    if (!id_filial_omie && id_filial_omie !== 0) {
      swal('Aviso!', 'Por favor, escolha uma filial para a carga da tabela de preços.', 'warning');
      return;
    }

    this.props.history.push({
      pathname: `/admin/omieTabelaPrecos/list/`,
      state: {
        cd_estabelecimento: id_filial_omie,
        nome_filial: nome_filial_omie,
        processo: 'Tabela de Preços OMIE',
      }
    })
  }

  goToOmieTabelaPrecosExec() {
    const { id_filial_omie, nome_filial_omie } = this.state;

    this.props.history.push({
      pathname: `/admin/omieTabelaPrecosExec/list/`,
      state: {
        cd_estabelecimento: id_filial_omie,
        nome_filial: nome_filial_omie,
        processo: 'Tabela de Preços OMIE',
      }
    })
  }

  render() {
    const self = this.state.getList;
    const headerStyles = { display: 'flex', justifyContent: 'space-between' };
    const operadoras = ['Next', 'Unilog'];
    const operadorasa = this.state.operadorasa;

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>NFs de Entrada</strong>
            </CCardHeader>
            <CCardBody>
              <CRow className="align-items-center">
                <CCol md={3}>
                  <CButton style={{ flexDirection: 'row', marginTop: 3, height: 37 }} width={100} onClick={this.CallLog}>Configurar e Enviar NFs</CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>NFs Outras Entradas</strong>
            </CCardHeader>
            <CCardBody>
              <CRow className="align-items-center">
                <CCol md={3}>
                  <CButton style={{ flexDirection: 'row', marginTop: 3, height: 37 }} width={100} onClick={this.CallLogEntradaOT}>Configurar e Enviar NFs</CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>NFs de Saída ( Notas de Vendas )</strong>
            </CCardHeader>
            <CCardBody>
              <CRow className="align-items-center">
                <CCol md={3}>
                  <CFormLabel><strong>Escolha uma Filial.</strong></CFormLabel>
                  <AutoSelect
                    className="basic-single"
                    onChange={this.handleSelectChanges}
                    isSearchable={true}
                    name="id2"
                    label="Escolha uma Filial"
                    options={Arrays(self, 'nome', 'cd_estabelecimento')}
                  />
                </CCol>

                <CCol md={3}>
                  <CFormLabel><strong>Logística.</strong></CFormLabel>
                  <CFormSelect
                    name="operadorasa"
                    value={operadorasa}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Selecione uma operadora</option>
                    {operadoras.map((item, index) => (
                      <option key={index} value={item}>{item}</option>
                    ))}
                  </CFormSelect>
                </CCol>
              </CRow>
              <CCol md={3}>
                <CButton style={{ flexDirection: 'row', marginTop: 10 }} width={80} onClick={this.EnviaSaida}>Enviar</CButton>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>NFs Outras Saídas ( Notas Remessas, Tranferência e etc ..)</strong>
            </CCardHeader>
            <CCardBody>
              <CCol md={3}>
                <CButton style={{ flexDirection: 'row', marginTop: 4 }} width={80} onClick={this.CallLogSaida}>Configurar e Enviar NFs</CButton>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>Carga pedidos</strong>
            </CCardHeader>
            <CCardBody>
              <CCol md={3}>
                <CButton style={{ flexDirection: 'row', marginTop: 4 }} width={80} onClick={this.CallPedidos}>Enviar Pedidos OMIE</CButton>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mb-4 border-primary">
            <CCardHeader style={headerStyles}>
              <strong>Tabelas de Preço OMIE</strong>
            </CCardHeader>
            <CCardBody>
              <CRow className="align-items-end">
                {/* <CCol md={4}>
                  <CFormLabel><strong>Escolha a Filial da planilha.</strong></CFormLabel>
                  <AutoSelect
                    className="basic-single"
                    onChange={this.handleSelectOmieTabelaPreco}
                    isSearchable={true}
                    name="id_filial_omie"
                    label="Escolha uma Filial"
                    options={Arrays(self, 'nome', 'cd_estabelecimento')}
                  />
                </CCol> */}

                <CCol md={8}>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 8 }}>
                    <CButton color="primary" onClick={this.goToOmieTabelaPrecos}>
                      Importar / Alterar Tabela de Preços
                    </CButton>
                    <CButton color="secondary" variant="outline" onClick={this.goToOmieTabelaPrecosExec}>
                      Acompanhar Execução
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    )
  }
}
